export interface NewSellerIdentifiers {
  company_name: string;
  website_url: string;
  linkedin_url?: string;
  industry?: string;
  /** ISO2 code of the selected country (e.g., "ES"). Mandatory. */
  country: string;
  /** Human-readable country name for display in N8N (e.g., "Spain"). */
  country_name?: string;
  /** Selected state name (free text or from dropdown). Optional. */
  state?: string;
  /** Selected city name. Optional. */
  city?: string;
  /** Free-form seller description, max 2500 characters. */
  description?: string;
}

interface BuildAddSellerParametersInput {
  newSeller: NewSellerIdentifiers;
  clientEmail: string;
  clientId?: string;
  teamName: string;
  timestamp?: string;
}

export const buildAddSellerParameters = ({
  newSeller,
  clientEmail,
  clientId,
  teamName,
  timestamp = new Date().toISOString(),
}: BuildAddSellerParametersInput) => {
  const normalizedTeamName = teamName.trim();
  if (!normalizedTeamName) {
    throw new Error('Appwrite team name is required to add a seller.');
  }

  return {
    new_seller: newSeller,
    client_email: clientEmail,
    client_id: clientId || '',
    client_name: normalizedTeamName,
    timestamp,
    source: 'lead-intelligence-app',
  };
};
